// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2sGcv","icon":"styles_icon__1kCdF"};